<template>
  <div class="item-row clearfix">
    <div class="item-r-l">
      <a-input
        :disabled="true"
        :default-value="itemData.fieldname"
      />
      <a-input
        :disabled="true"
        :default-value="$t('message[1755]')"
      />
      <a @click="setOption">{{ $t('message[1037]') }}</a>
    </div>
    <div class="item-r-r">
      <a-checkbox
        :default-checked="!!itemData.isenable"
        :disabled="!itemData.ischangeenable"
        @change="enableChange"
      >
        {{ $t('message["728"]') }}
      </a-checkbox>
      <a-checkbox
        :checked="!!itemData.isneeded"
        :disabled="!itemData.ischangeneeded || !itemData.isenable"
        @change="needChange"
      >
        {{ $t('message["33"]') }}
      </a-checkbox>
    </div>
    <tree-dialog
      ref="treeDialog"
      :item-data="itemData"
      @confirm="handleConfirm"
    />
  </div>
</template>

<script>
import TreeDialog from './../tree/TreeDialog'

export default {
  components: {
    TreeDialog
  },

  props: {
    itemData: {
      type: Object,
      default () {
        return {
        }
      }
    }
  },

  inject: ['myForm'],

  data () {
    return {
      data: {
        options: [{
          id: 1,
          level: 1,
          name: '商务通接待',
          children: [{
            id: 11,
            level: 2,
            name: '帐号1'
          }, {
            id: 12,
            level: 2,
            name: '帐号2'
          }]
        }, {
          id: 2,
          level: 1,
          name: '电话接待'
        }, {
          id: 3,
          level: 1,
          name: '邮箱接待'
        }, {
          id: 4,
          level: 1,
          name: '在线留言',
          children: [{
            id: 11,
            level: 2,
            name: '帐号1'
          }, {
            id: 12,
            level: 2,
            name: '帐号2'
          }]
        }]
      }
    }
  },

  methods: {
    setOption () {
      this.$refs.treeDialog.changeVisible(true)
    },
    enableChange (item) {
      if (item.target.checked) {
        this.itemData.isenable = 1
        this.disable = false
      } else {
        this.itemData.isenable = 0
        this.itemData.isneeded = 0
        this.disable = true
      }
      this.$emit('change', this.itemData)
    },
    needChange (e) {
      if (e.target.checked) {
        this.itemData.isneeded = 1
      } else {
        this.itemData.isneeded = 0
        this.disable = true
      }
      this.$emit('change', this.itemData)
    },
    handleConfirm (options) {
      this.itemData.options = options
      this.$emit('change', this.itemData)
    }
  }
}
</script>

<style lang="scss" scoped>
.item-row::v-deep {
  margin-bottom: 24px;
  .item-r-l {
    float: left;
    padding-left: 30px;
    .ant-input {
      width: 240px;
      margin-right: 24px;
      &:nth-child(2) {
        margin-right: 16px;
      }
    }
  }
  .item-r-r {
    float: right;
    width: 190px;
    text-align: left;
    ::v-deep .ant-checkbox-wrapper {
      margin-right: 24px;
      &.last-child {
        margin-right: 0;;
      }
    }
    .ant-checkbox-wrapper + span, .ant-checkbox + span {
      padding:0 0 0 2px;
    }
  }
}
</style>
